/**
 * Datums-, Zeit- und Groessenformate fuer die Anzeige, einmal fuer alle Seiten.
 *
 * Bis zum 05.09.2026 hatte fast jede Admin-Seite ihre eigene Kopie davon (`formatTimestamp`,
 * `formatTs`, `formatDate`, `formatNewsDate`, `formatBytes`) — gleicher Code, verschiedene
 * Namen, und die Leerwert-Ersatzzeichen drifteten auseinander (`''`, `–`, `—`). Der Ersatz
 * fuer einen fehlenden Wert bleibt deshalb ein Parameter: er ist eine Entscheidung der
 * jeweiligen Tabelle, nicht des Formats.
 */

const LOCALE = 'de-DE';

// Die Datumsformate liegen seit dem 25.09.2026 in `@radevents/shared` (`dateFormat.ts`), damit
// Web und App dasselbe Datum gleich schreiben. Re-export, damit die Seiten nichts umstellen müssen.
export { formatDateTime, formatDayLong, formatDayShort, formatDayWeekday, formatDayMonth, formatDayRange } from '@radevents/shared';

/** Dateigroesse als „1,3 MB" bzw. „420 KB" — nie „0 KB", eine Datei hat immer Inhalt. */
export const formatBytes = (n: number): string =>
  n >= 1024 * 1024
    ? `${(n / 1024 / 1024).toLocaleString(LOCALE, { maximumFractionDigits: 1 })} MB`
    : `${Math.max(1, Math.round(n / 1024)).toLocaleString(LOCALE)} KB`;
